(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nexo-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nexo-viewport-hero')) {
  customElements.define('nexo-viewport-hero', class extends HTMLElement {
    connectedCallback() {
      this.updateOffset = () => {
        if (!this.isConnected) return;
        if (this.dataset.offsetMode === 'auto') {
          const top = Math.max(0, Math.round(this.getBoundingClientRect().top + window.scrollY));
          this.style.setProperty('--nx-offset', `${top}px`);
        }
        if (this.dataset.reserveMode === 'none') this.style.setProperty('--nx-reserve', '0px');
        if (this.dataset.reserveMode !== 'auto') return;
        const wrapper = this.closest('.shopify-section');
        let next = wrapper ? wrapper.nextElementSibling : null;
        const targets = [];
        const usps = next?.querySelector('.nx-usps');
        if (usps) {
          targets.push(usps);
          next = next.nextElementSibling;
        }
        const choices = next?.querySelector('.nx-choices');
        const grid = choices?.querySelector('.nx-choices__grid');
        if (choices) targets.push(choices);
        const bottom = grid ? grid.getBoundingClientRect().top : usps?.getBoundingClientRect().bottom;
        const reserved = Number.isFinite(bottom) ? Math.max(0, Math.round(bottom - this.getBoundingClientRect().bottom)) : 0;
        this.style.setProperty('--nx-reserve', `${reserved}px`);
        if (this.observer) targets.forEach(el => this.observer.observe(el));
      };
      this.scheduleOffset = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.updateOffset);
      };
      this.scheduleOffset();
      window.addEventListener('resize', this.scheduleOffset);
      window.addEventListener('load', this.scheduleOffset);
      this.editorUpdate = () => {
        if (this.observer) this.observer.disconnect();
        this.observeHeaders();
        this.scheduleOffset();
      };
      this.observeHeaders = () => {
        if (!this.observer) return;
        document.querySelectorAll('.shopify-section-group-header-group, header').forEach(el => {
          if (el.compareDocumentPosition(this) & Node.DOCUMENT_POSITION_FOLLOWING) this.observer.observe(el);
        });
      };
      ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(name => document.addEventListener(name, this.editorUpdate));
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.scheduleOffset);
        this.observeHeaders();
      }
      if (document.fonts) document.fonts.ready.then(() => this.scheduleOffset());
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.scheduleOffset);
      window.removeEventListener('load', this.scheduleOffset);
      ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(name => document.removeEventListener(name, this.editorUpdate));
      if (this.observer) this.observer.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
